import { NgModule , CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartistModule } from 'ng-chartist';
import { SharedModule } from '../../shared/shared.module';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { DocumentosPorFirmarComponent } from './documentos-por-firmar/documentos-por-firmar.component';
import { DocumentosPorFirmarRoutingModule } from './documentos-por-firmar-routing.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [DocumentosPorFirmarComponent],
  imports: [
    CommonModule,    
    SharedModule,
    NgChartsModule,
    Ng2GoogleChartsModule,
    NgxChartsModule,
    ChartistModule,
    NgbCollapseModule,
    DocumentosPorFirmarRoutingModule , 
    ReactiveFormsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DocumentosPorFirmarModule { }
